import { render, staticRenderFns } from "./buttonstoolbar.vue?vue&type=template&id=54b95dea&"
import script from "./buttonstoolbar.vue?vue&type=script&lang=js&"
export * from "./buttonstoolbar.vue?vue&type=script&lang=js&"
import style0 from "./buttonstoolbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54b95dea')) {
      api.createRecord('54b95dea', component.options)
    } else {
      api.reload('54b95dea', component.options)
    }
    module.hot.accept("./buttonstoolbar.vue?vue&type=template&id=54b95dea&", function () {
      api.rerender('54b95dea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/buttonstoolbar.vue"
export default component.exports